import { Role } from '@/constants/role.js'
//
export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('@pages/p-login'),
        meta: { authorize: [] },
    },
    {
        path: '/register',
        component: () => import('@pages/p-register'),
        name: 'register',
        meta: { authorize: [] },
    },
    {
        path: '/register/verify',
        component: () => import('@pages/p-verify'),
        props: route => {
            return {
                code: route.query.code,
                login: route.query.login,
            }
        },
    },
    {
        path: '/google-oauth',
        redirect: to => {
            const parts = to.query.state.split('@');
            return {
                name: "project-resources",
                params: {
                    projectUuid: parts[0]
                },
                query: {
                    externalDocId: parts[1],
                    code: to.query.code,
                    state: to.query.state
                }
            }
        }
    },
    {
        path: '/confirm/verify',
        component: () => import('@pages/p-confirm'),
        props: route => {
            return {
                code: route.query.code,
                login: route.query.login,
                projectUuid: route.query.projectUuid,
            }
        },
    },
    {
        path: '/recover/verify',
        component: () => import('@pages/p-recover'),
        props: route => {
            return {
                code: route.query.code,
                login: route.query.login,
            }
        },
    },
    {
        path: '/password-forgot',
        name: 'password-forgot',
        component: () => import('@pages/p-password-forgot'),
    },
    {
        path: '/set-password',
        component: () => import('@pages/p-set-password'),
        name: 'set-password',
        meta: { authorize: [Role.user] },
    },
]
